/* angular:styles/component:css;092a9dc575e5cb97b0f6451b26cfc13c4093882eecffedffe78d7c8d082d3e35;C:\RDF\github-dev\fusion-web\src\app\components\issue-tracker\issue-tracker.component.ts */
.priority-high {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--gold-600);
  font-weight: var(--weight-semibold);
  text-transform: capitalize;
}
.priority-high lucide-icon {
  color: var(--gold-500);
}
/*# sourceMappingURL=issue-tracker.component.css.map */
